import {
  idColumn,
  actionColumn,
  statusColumn,
} from "../../../../../utils/commonColumns";
import { generateColumn } from "../../../../../utils/commonFunctions";

const useColumnDefs = [
    idColumn,
    {
      ...generateColumn("", "experience"),
      cellRenderer: (props: any) => {
        return props.value;
      },
    },
    {
      ...generateColumn("", "zero_experience"),
      cellRenderer: (props: any) => {
        return props.value;
      },
    },
    {
      ...generateColumn("Level 1 Supporting Activities", "level_1"),
      cellRenderer: (props: any) => {
        return props.value;
      },
    },
    {
      ...generateColumn("Level 2 Executing Activities", "level_2"),
      cellRenderer: (props: any) => {
        return props.value;
      },
    },
    {
      ...generateColumn("Level 3 Managing Activities", "level_3"),
      cellRenderer: (props: any) => {
        return props.value;
      },
    },
    {
      ...generateColumn("Level 4 Planning Strategic Work", "level_4"),
      cellRenderer: (props: any) => {
        return props.value;
      },
    },
    {
      ...generateColumn("Level 5 Leading Strategic Work", "level_5"),
      cellRenderer: (props: any) => {
        return props.value;
      },
    },
    statusColumn,
    actionColumn,
  ];
export default useColumnDefs;
